module.exports = __webpack_public_path__ + "static/media/smile4.c9c7493a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/smileImg/smile4.png
// module id = 77
// module chunks = 0